export const parseLabels = (data) => {
  data.forEach((label) => {
    label.label = label.codeName;
    label.value = label.codeName;
  });

  return data;
};

export const parseClassLabels = (data) => {
  data &&
    data.forEach((label) => {
      label.label = label.codeName;
      label.value = label.codeName;
      label.color = getClassName(label.color);
    });
  return data;
};

export const parsePublicKeys = (data) => {
  data &&
    data.forEach((publicKey) => {
      publicKey.valueAux = publicKey.value;
      publicKey.labelAux = publicKey.label;
      publicKey.label = publicKey.name;
      publicKey.value = publicKey.id;
    });
  return data;
};

const getClassName = (color) => {
  let className;
  switch (color) {
    case "#1d8cf8":
      className = "info";
      break;
    case "#00f2c3":
      className = "success";
      break;
    case "#ff8d72":
      className = "warning";
      break;
    case "#f63b3b":
      className = "danger";
      break;
    case "#0d6efd":
      className = "primary-force";
      break;
    default:
      className = color;
      className = "primary-force";
      break;
  }

  return className;
};

export const getColorName = (color) => {
  let colorName;
  switch (color) {
    case "info":
      colorName = "#1d8cf8";
      break;
    case "success":
      colorName = "#00f2c3";
      break;
    case "warning":
      colorName = "#ff8d72";
      break;
    case "danger":
      colorName = "#f63b3b";
      break;
    default:
      colorName = "#0d6efd";
      break;
  }

  return colorName;
};
